import { VisibilityStatus } from "./VisibilityStatus";

export type Offer = {
    id: string;
    retailerId: string;
    locationIds: string[];
    displayName: string;
    details: string;
    imageUrl: string;
    availability: Availability;
    locationType: OfferLocationType;
    codeDisplayType: OfferCodeDisplayType;
    codeType: OfferCodeType;
    redeemCode: string;
    redeemInstructions: string;
    hasChanges?: boolean;
    visibility: VisibilityStatus;
    // id: string;
    // retailer_location_id: string;
    // display_name: string;
    // details: string;
    // image_url: string;
    // availability: Availability;
    // location_type: OfferLocationType;
    // code_display_type: OfferCodeDisplayType;
    // code_type: OfferCodeType;
    // redeem_code?: string;
    // redeem_instructions?: string;
}

export enum OfferLocationType
{
    Anywhere = 0,
    OnPremise = 1
}

export enum OfferCodeDisplayType
{
    None = 0,
    Text = 1<<0,
    QRCode = 1<<1,
    Barcode = 1<<2
}

export enum OfferCodeType
{
    None = 0,
    Static = 1,
    OneTimeUse = 2
}


export class Availability
{
    

    startDate?: Date;
    endDate?: Date;

    startTimeOfDay?: string;
    endTimeOfDay?: string;

    availableDays?: DayFlags;
}

export enum DayFlags 
{
        Sunday = 1>>0,
        Monday = 1>>1,
        Tuesday = 1>>2,
        Wednesday = 1>>3,
        Thursday = 1>>4,
        Friday = 1>>5,
        Saturday = 1>>6,
        WeekDays =  Monday | Tuesday | Wednesday | Thursday |Friday,
        WeekEnds = Saturday | Sunday,
        AllWeek = WeekDays | WeekEnds
}